import * as React from 'react';

import LabelPrimitive from './LabelPrimitive';

var HIDDEN_CLASS_NAME = 'accessibility-hidden';

var HiddenLabel = function HiddenLabel(_ref) {
    var children = _ref.children,
        labelContent = _ref.labelContent;
    return React.createElement(
        LabelPrimitive,
        { labelContent: labelContent, className: HIDDEN_CLASS_NAME },
        children
    );
};

HiddenLabel.propTypes = {
    children: PropTypes.node.isRequired,
    labelContent: PropTypes.node.isRequired
};
export default HiddenLabel;
import PropTypes from 'prop-types';